import { emitPermissionDeniedEvent } from './permissionDeniedEvents'
import { parseStoredUser } from './authSession'

/**
 * Intercepts Create action clicks in topbar / list headers.
 * Allows action if user is Admin or has the required privilege.
 */
export function guardCreateAction(targetRoute, routeLabel = '', requiredPrivilege = null) {
  const user = parseStoredUser()
  if (user.isAdmin) {
    return { allowed: true }
  }

  if (requiredPrivilege && !user.privileges.includes(requiredPrivilege)) {
    emitPermissionDeniedEvent({
      action: 'create',
      routeLabel: String(routeLabel || '').trim() || 'Current Module',
      source: 'ui:create-action',
    })
    return { allowed: false }
  }

  return { allowed: true }
}
